export default {
      id: "link-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#link",
      toString: function () {
        return this.url;
      }
    }